import type { FC } from 'react';
import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons';

import type { MetricFormat } from '../../../config/metrics';
import { formatMetricValue } from '../../../utils/formatMetricValue';
import type { DeltaColors } from '../../../config/scenarioComparisonConfig';

/**
 * With the abs/percent toggle on, the backend returns the delta as a percentage
 * of the base, so it is a RATIO and drops the KPI's own adornments. 1dp preserves
 * how this chip has always rendered percentages.
 */
const PERCENT_DELTA_FORMAT: MetricFormat = { allowedDecimals: 1, preUnit: '', postUnit: '%' };

interface DeltaIndicatorProps {
    delta: number | null;
    isPercent?: boolean;
    /** The KPI's own format, used when the toggle is on `abs`. */
    format: MetricFormat;
    colors: DeltaColors;
}

const DeltaIndicator: FC<DeltaIndicatorProps> = ({ delta, isPercent, format, colors }) => {
    if (delta == null || delta === 0) return null;

    const isPositive = delta > 0;

    return (
        <span
            className="flex items-center gap-0.5 text-xs"
            style={{ color: isPositive ? colors.positive : colors.negative }}
        >
            {isPositive ? (
                <CaretUpFilled className="text-[10px]" />
            ) : (
                <CaretDownFilled className="text-[10px]" />
            )}
            {formatMetricValue(Math.abs(delta), isPercent ? PERCENT_DELTA_FORMAT : format)}
        </span>
    );
};

DeltaIndicator.displayName = 'DeltaIndicator';
export default DeltaIndicator;
